import { render, staticRenderFns } from "./settingsMonitor.vue?vue&type=template&id=27cd377c&scoped=true&"
import script from "./settingsMonitor.vue?vue&type=script&lang=js&"
export * from "./settingsMonitor.vue?vue&type=script&lang=js&"
import style0 from "./settingsMonitor.vue?vue&type=style&index=0&id=27cd377c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27cd377c",
  null
  
)

export default component.exports